import { VK_UI_DARK_THEME } from 'reactApp/constants';

export const isDarkThemeModeEnabled = (enabled = true) => {
    if (typeof window === 'undefined') {
        return false;
    }

    return document.body.classList.contains(VK_UI_DARK_THEME) && enabled;
};
